import { resolveImageGenError } from '../translations.js';

const SFW_MODERATION_CODES = new Set([
  'sfw_moderation_rejected_file',
  'sfw_moderation_rejected_prompt',
  'sfw_moderation_unavailable',
]);

export const sfwModerationMessage = (error) => {
  const code = [
    error?.body?.code,
    error?.data?.code,
    error?.code,
    error?.body?.error,
    error?.data?.error,
    error?.message,
  ].find((value) => SFW_MODERATION_CODES.has(value));
  if (!code) return '';
  return resolveImageGenError(code);
};
